// extracted by mini-css-extract-plugin
module.exports = {"Banner":"CelebratingUs_Banner__ZCqZ2"};